import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../../../shared/util/util';
import {trackEvent} from '../../../../../tracking/amplitude/TrackingV2';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../../../../mutations/MutationTypes';
import {
	DuplicateBaselineTemplateInput,
	DuplicateBaselineTemplateMutation,
} from './__generated__/DuplicateBaselineTemplateMutation.graphql';

const mutation = graphql`
	mutation DuplicateBaselineTemplateMutation($input: DuplicateBaselineTemplateInput!) {
		duplicateBaselineTemplate(input: $input) {
			baselineTemplate {
				id
				name
			}
			company {
				id
				...BaselineTemplatesList_company
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<DuplicateBaselineTemplateInput>,
	onSuccess?: RelayOnCompleted<DuplicateBaselineTemplateMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<DuplicateBaselineTemplateMutation>(environment, {
		mutation,
		variables,
		onCompleted: (response, errors) => {
			if (!errors?.length) {
				trackEvent('Baseline Template', 'Duplicated');
			}
			onSuccess?.(response, errors);
		},
		onError: onError,
	});
}

export default {commit};
